wc.service.declare({
	id: "AjaxEmailSignupCmd",
	actionId: "AjaxEmailSignupCmd",
	url: getAbsoluteURL() +"PetcoEmailSignup",
	formId: "emailSignup"

		,successHandler: function(serviceResponse) {
	cursor_clear();
	var errMsg_div =  dojo.byId('error_message_server');			
	var errorCode = serviceResponse.errorCode;
	var msg="";
	var successMsg = serviceResponse.successMessage;

	if(successMsg != 'undefined'){
		msg = '<p class="success-box">'+serviceResponse.successMessage+'</p>';
		errMsg_div.innerHTML = msg;

	}
	else if(errorCode != 'undefined' || errorCode != null){
		var errMsg = MessageHelper.messages[errorCode];
		msg = MessageHelper.messages[errorCode];
		errMsg_div.innerHTML = '<p class="error-box">'+msg+'</p>';


			}
	petcoCommonJS.showModal('emailsignupwidget');

	var formName = document.getElementById("emailSignup");
	$(':input', formName).each(function () {
		var type = this.type;
		var id = this.id;
		if (type == 'text')
			this.value = "";
	}); 
}

,failureHandler: function(serviceResponse) {
	cursor_clear();

		var errorCode = serviceResponse.errorCode;
	var errMsg_div =  dojo.byId('error_message_server');

	console.debug("error code:"+errorCode);
	if(errorCode != 'undefined' && errorCode != null && errorCode == 'PETCOUPDATEEMAILSUBSCRIPTION.SBL-EXL-00151'){
		errMsg_div.innerHTML = '<p class="error-box">An account exists for the email address entered. Please enter a different email address or sign in to your account to manage your Newsletter Subscriptions.</p>';
	}else{
		errMsg_div.innerHTML = '<p class="error-box">'+ serviceResponse.errorMessage + '</p>';
	}
	petcoCommonJS.showModal('emailsignupwidget');

	var formName = document.getElementById("emailSignup");
	$(':input', formName).each(function () {
		var type = this.type;
		var id = this.id;
		if (type == 'text')
			this.value = "";
	}); 

}
});